module.exports = __webpack_public_path__ + "static/media/10gb.727c1cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/10gb.png
// module id = 84
// module chunks = 0